import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { childOfKey } from '../models/childKeys';
import { TgvActions } from '../tgvActions';
import { sharedDispatcher } from './sharedDispatcher';

export function* markAndDeleteKeys(keys: string[]): SagaIterator {
  yield put(new TgvActions().pendingDeletionMarked(keys));
  sharedDispatcher().dispatch(new GlobalActions().produktDeleted(keys.map(childOfKey)));
}
